export default __webpack_public_path__ + "static/M-0_03-23b96dcbc511deebb524f6bb4454ba90.png";